import React, { Fragment } from 'react';

import withAuthServerSideProps from '@/libs/auth';
import { PageLayout } from '@/layouts/shared';
import { GetServerSidePropsContext } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import MetaTag from '@/components/ui/MetaTag';
import { Icon, Image, Link, HomeIconActive, ClockSolidIcon } from '@/components';

const ShopsPage = () => {
  const shops = [
    {
      name: 'Chi nhánh Hồ Chí Minh',
      image: '/shop-hcm.jpg',
      address: '89A Nguyễn Trãi, Phường Bến Thành, Quận 1, Tp.HCM, Việt Nam',
      map: 'https://www.google.com/maps/place/An+Th%C6%B0+Jewellery/@10.7698821,106.6889064,17z/data=!4m15!1m8!3m7!1s0x31752f3da5f5bb57:0xd777e541a8968d18!2zODlBIMSQLiBOZ3V54buFbiBUcsOjaSwgUGjGsOG7nW5nIFBo4bqhbSBOZ8WpIEzDo28sIFF14bqtbiAxLCBUaMOgbmggcGjhu5EgSOG7kyBDaMOtIE1pbmgsIFZp4buHdCBOYW0!3b1!8m2!3d10.7698768!4d106.6914813!16s%2Fg%2F11j8h0h9cp!3m5!1s0x31752fd8ef5380a5:0x665b54ed78b96721!8m2!3d10.7698794!4d106.6914768!16s%2Fg%2F11g_vdk8nl?hl=vi-VN',
      phone_url: '0333336789',
      phone: '033 333 6789',
      time: '09:00 - 21:00',
    },
  ];
  return (
    <Fragment>
      <MetaTag title="Hệ thống chi nhánh An Thư" description="Hệ thống chi nhánh An Thư" />
      <div className="container tw-mx-auto md:tw-border-t tw-border-primary-main  tw-pt-8 tw-pb-10 tw-text-secondary-70">
        <h1 className="tw-text-[30px] tw-font-semibold tw-text-center">Hệ thống chi nhánh An Thư</h1>
        <div className="tw-grid tw-gap-10 md:tw-gap-16 tw-mt-10">
          {shops.map((shop) => {
            return (
              <div className="md:tw-flex tw-gap-6 lg:tw-gap-10" key={shop.name}>
                <h2 className="tw-block md:tw-hidden tw-font-semibold">{shop.name}</h2>
                <div
                  className="tw-w-full tw-h-[250px] md:tw-w-[300px] md:tw-h-[200px] tw-rounded-5 tw-mt-2 lg:tw-mt-0 tw-bg-center tw-bg-cover"
                  style={{ backgroundImage: `url('${shop.image}')` }}
                ></div>
                <div className="tw-w-full tw-flex tw-flex-col tw-gap-2 tw-flex-1 tw-mt-6 md:tw-mt-0">
                  <h2 className="tw-font-semibold tw-hidden md:tw-block">{shop.name}</h2>
                  <div className="tw-flex  tw-gap-10 tw-flex-col">
                    <div className="tw-flex tw-flex-1">
                      <Icon icon={<HomeIconActive />} className="tw-w-6 tw-h-6 tw-mr-2 tw-text-primary-main " />
                      <div className="tw-flex-1 tw-flex tw-flex-col lg:tw-flex-row tw-justify-between tw-gap-2 lg:tw-gap-10  lg:tw-items-end">
                        <span className="tw-flex-1">{shop.address}</span>
                        <Link target="_blank" url={shop.map}>
                          <span className="tw-underline tw-decoration-solid">Xem bản đồ</span>
                        </Link>
                      </div>
                    </div>
                  </div>
                  <Link url={`tel:${shop.phone_url}`} className="tw-flex tw-items-center">
                    <Image alt="call" src="/call.svg" objectFit="contain" className={`tw-w-6 tw-h-6 tw-mr-2`} />
                    <span className="tw-text-secondary-70">{shop.phone}</span>
                  </Link>
                  <div className="tw-flex tw-items-center">
                    <Icon icon={<ClockSolidIcon />} className="tw-w-6 tw-h-6 tw-mr-2 tw-text-primary-main" />
                    <span className="tw-flex-1">{shop.time}</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </Fragment>
  );
};

export const getServerSideProps = withAuthServerSideProps(
  async ({ locale }: GetServerSidePropsContext) => {
    return {
      props: {
        layout: PageLayout.New,
        ...(await serverSideTranslations(locale as string, ['layout'])),
      },
    };
  },
  { isAntiAuth: false, isPublic: true }
);

export default ShopsPage;
